import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";

declare var ko: any;

export class newsletterTemplateList_template extends vnTemplate {


    //As VM
    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;

    protected initPartial() {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
    }

    public getViewModelForRequest(): any {

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters : {
                keywords : this.getTemplateViewModel().filter.filterKeyword
            },
        }
    }

    protected buildViewModel(): any {

        let self = this
        return {
            templates: ko.observableArray([]),
            orderBy: ko.observable("template.id"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("template.id_DESC"),
            idTemplateToDelete: ko.observable(null),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewTemplate: (data, event) => {
                self.viewTemplate(data.id, event);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd()
            },
            onClickManageImages: (data, event) => {
                self.onClickManageImages()
            },
            onClickManageColors: (data, event) => {
                self.onClickManageColors()
            },
            onClickShowPopUp : (data, event) =>{
                self.onClickShowPopUp(data)
            },
            onClickHidePopUp : (data, event)=>{
                self.onClickHidePopUp()
            },
            onClickDelete : (data, event)=>{
                self.onClickDelete()
            }
        }
    }

    protected getTemplateHtml(): string {

        return (`
        <div class="list-header w-justify newsletter-template-list-header">
            <div class="w-left" >
                    <button data-bind="event: {click: onClickAdd}" class="btn secondary icon i-add" type="button">Create Template</button>    
                    <button data-bind="event: {click: onClickManageImages}" class="btn secondary icon i-image-2" type="button">Manage Images</button>
                    <button data-bind="event: {click: onClickManageColors}" class="btn secondary icon i-color" type="button">Manage Colors</button>
            </div>
            <div class="w-center">
                <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                    <div class="w-search-feild icon i-search2">
                        <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                        <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                        <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                        <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                    </div>
                </div>
            </div>
            <div class="w-right">
                ` + this.pagination.getHtmlBuild() + `
            </div>
        </div>
        
        <div class="w-list-results" id="list-results">
            <table class="list-results">
                ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'template.id') }, css: { 'list-sort-desc': orderByAndDirection()=='template.id_DESC', 'list-sort-asc': orderByAndDirection()=='template.id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'template.name') }, css: { 'list-sort-desc': orderByAndDirection()=='template.name_DESC', 'list-sort-asc': orderByAndDirection()=='template.name_ASC' }">Title</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'template.senderName') }, css: { 'list-sort-desc': orderByAndDirection()=='template.senderName_DESC', 'list-sort-asc': orderByAndDirection()=='template.senderName_ASC' }">Sender Email Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'sender.name') }, css: { 'list-sort-desc': orderByAndDirection()=='sender.name_DESC', 'list-sort-asc': orderByAndDirection()=='sender.name_ASC' }">Sender Email Address</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'template.dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='template.dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='template.dateCreated_ASC' }">Date Created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'template.dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='template.dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='template.dateUpdated_ASC' }">Date Updated</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: templates">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.viewTemplate } "><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.viewTemplate } "><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: name"></span></a></td>                          
                            <td data-bind="event: { click: $parent.viewTemplate } "><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: senderName"></span></a></td>    
                            <td data-bind="event: { click: $parent.viewTemplate } "><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: sender.name"></span></a></td>                       
                            <td data-bind="event: { click: $parent.viewTemplate } "><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateCreated"></span></a></td>
                            <td data-bind="event: { click: $parent.viewTemplate } "><a class="right-click" data-bind="attr: { href : emakiView }"><span data-bind="text: dateUpdated"></span></a></td>
                        </tr>
                    </tbody>
                </table>
            </div> 
            
            
            <div id="delete-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Deleting Template</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This action is irreversible</p>
                                <p class="form-text">Are you sure you want to delete this template?</p>
                            </div>
                         </div>
                
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                        </div>
                    </div>
                   
                </div>
            </div>
        `);
    }

    protected getTemplateName(): string {

        return "newsletterTemplateList_template";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-content"];
    }

    protected getMainElementType(): string {

        return "div";
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    protected viewTemplate(data, event): any {

        this.caller.view(data)
    }

    protected onClickReorder(value, data, event): any {

        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.templatesListReorder();
    }

    onClickAdd(): any {

        this.caller.add()
    }

    onClickManageImages(): any {

        this.caller.manageImages()
    }

    onClickManageColors(): any {

        this.caller.manageColors()
    }

    onClickDelete() {

        let id = this.getTemplateViewModel().idTemplateToDelete();
        this.toggleDeleteDialogVisibility();
        this.caller.delete(id);
    }

    onClickHidePopUp(): any {

        this.getTemplateViewModel().idTemplateToDelete(null);
        this.toggleDeleteDialogVisibility()
    }
    onClickShowPopUp(data): any {

        this.getTemplateViewModel().idTemplateToDelete(data);
        this.toggleDeleteDialogVisibility()
    }

    //Action on view model
    public setTemplates(templates, brandId) {

        templates.forEach((t) => t['emakiView'] = '/brand/' + brandId + '/newsletter/templates/view/' + t.id );
        this.getTemplateViewModel().templates(templates)
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/newsletterTemplateList_template.ts